import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "b-user-list qa-user-list" }
const _hoisted_2 = { class: "b-user-list__inner h-pv-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserItem = _resolveComponent("UserItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localList, (user) => {
        return (_openBlock(), _createBlock(_component_UserItem, {
          key: user.id,
          userData: user,
          class: "b-user-list__item",
          isActive: _ctx.userFilterIds.includes(user.id),
          onClick: ($event: any) => (_ctx.$emit("click", user))
        }, null, 8, ["userData", "isActive", "onClick"]))
      }), 128))
    ])
  ]))
}